"use client";

import { useEffect, useRef } from "react";
import { useSession } from "next-auth/react";
import { usePathname } from "next/navigation";

export function OnboardingGuard() {
  const { data: session, status } = useSession();
  const pathname = usePathname();
  const hasRedirectedRef = useRef(false);

  useEffect(() => {
    if (status !== "authenticated") {
      hasRedirectedRef.current = false;
      return;
    }

    const needsOnboarding = session?.user?.needsOnboarding === true;

    // Reset ref when onboarding completes so a future needsOnboarding=true
    // (e.g. from a failed session.update in welcome/page.tsx) triggers again.
    if (!needsOnboarding) {
      hasRedirectedRef.current = false;
      return;
    }

    const isExemptPath =
      pathname === "/apps" ||
      pathname.startsWith("/apps/") ||
      pathname.startsWith("/welcome") ||
      pathname.startsWith("/auth/");

    if (isExemptPath || hasRedirectedRef.current) {
      return;
    }

    hasRedirectedRef.current = true;
    window.location.replace("/welcome");
  }, [pathname, session?.user?.needsOnboarding, status]);

  return null;
}
